import React from 'react';
import { useContext } from 'react';
import SpoolsState from '../../../context/spools/SpoolsState';
import themeContext from '../../../context/theme/themeContext';
import Cover from '../../../layout/Cover';
import AvailableSpools from './AvailableSpools';
import Faq from './Faq';

const JoinASpool: React.FC = () => {
    const { theme } = useContext(themeContext);

    return (
        <div className={`app-tab join ${theme}`}>
            <Cover className='available-spools'>
                <SpoolsState initialSortKey='tvr'>
                    <AvailableSpools />
                </SpoolsState>
            </Cover>
            <Faq />
        </div>
    );
};

export default JoinASpool;
